import {React,useState} from 'react'
import { Navbar,NavbarBrand,NavLink,Collapse,NavItem,Nav,NavbarToggler } from 'reactstrap';
import clogo from "../assets/clogo.png"
import { Link } from "react-router-dom";

const Header = ()=> {
    const [collapsed, setCollapsed] = useState(true);

    const toggleNavbar = () => setCollapsed(!collapsed);

    return (
        <Navbar dark>
        <NavbarBrand href="/" className="mr-auto cit"><img src={clogo} alt="cit-logo" height="60rem"></img></NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav navbar>
            <NavItem>
              <NavLink href="#event">Events</NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={Link} to="/thanks">Thanks</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    )
}
export default Header;